import { render, staticRenderFns } from "./HomeIcon.vue?vue&type=template&id=d12a652e&"
import script from "./HomeIcon.vue?vue&type=script&lang=js&"
export * from "./HomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports